
export const ApiKey = {


  apiKey: "AIzaSyCXxpA8eME6_QqSI_k_M1ILmi1CipFWrHk",

  authDomain: "secmsg23.firebaseapp.com",

  projectId: "secmsg23",

  storageBucket: "secmsg23.appspot.com",

  messagingSenderId: "215087855006",

  appId: "1:215087855006:web:deff6786758600ccbf128f",

  measurementId: "G-E2K83JBJ2E"


};


  // apiKey: "AIzaSyAXYpCFO0GwEhJMPuCYBZ7fnLCdaEgaG9M",

  // authDomain: "secretmsg-797a0.firebaseapp.com",

  // projectId: "secretmsg-797a0",

  // storageBucket: "secretmsg-797a0.appspot.com",

  // messagingSenderId: "1002663514627",

  // appId: "1:1002663514627:web:aae7afbbda52d2b7563436"
